// extracted by mini-css-extract-plugin
export default {"day":"issueDateCalendar_day__Q0dt5"};